import { type MCPServerInfo } from '../../types';

const FigmaServer: MCPServerInfo = {
  serverId: 'FIGMA',
  name: 'Figma',
  slug: 'figma',
  description: 'Figma MCP Server',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.figma.com/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default FigmaServer;
